// src/theme.js
const THEME_STORAGE_KEY = "urban-portal-theme"; // "system" | "light" | "dark"

export function getThemePreference() {
    if (typeof window === "undefined") return "system";
    const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === "light" || stored === "dark" || stored === "system") {
        return stored;
    }
    return "system";
}

function getSystemTheme() {
    if (typeof window === "undefined" || !window.matchMedia) return "light";
    return window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";
}

export function getEffectiveTheme(preference) {
    if (preference === "light" || preference === "dark") {
        return preference;
    }
    return getSystemTheme();
}

export function applyThemePreference(preference) {
    if (typeof document === "undefined") return;

    const effective = getEffectiveTheme(preference);

    // This is what your CSS will key off:
    document.documentElement.setAttribute("data-theme", effective);

    try {
        window.localStorage.setItem(THEME_STORAGE_KEY, preference);
    } catch {
        // ignore storage errors
    }
}